// File generated by NTypewriter using scriban template (_Models.nt), DO NOT MODIFY THIS FILE
/* tslint:disable */
/**
 * 
 */
export enum GovernmentBillStage {

    /**
     *
     */
    First = 0,

    /**
     *
     */
    Second = 1,

    /**
     *
     */
    Third = 2,

    /**
     *
     */
    Committee = 3
}

/**
 * Property names of this type
 */
export const GovernmentBillStage_DISPLAY_NAMES = {

    /**
     *
     */
    [0]: "First",

    /**
     *
     */
    [1]: "Second",

    /**
     *
     */
    [2]: "Third",

    /**
     *
     */
    [3]: "Committee"

};


// WEBPACK FOOTER //
// ./src/model/autogen/GovernmentBillStage.ts